import {
  V2ListLineOfBusinessesForAccountApiArg,
  useV2ListLineOfBusinessesForAccountQuery,
} from "@generated";
import type { LineOfBusiness } from "../types";

export interface UseLinesOfBusinessListArgs {
  page?: V2ListLineOfBusinessesForAccountApiArg["page"];
  filter?: V2ListLineOfBusinessesForAccountApiArg["filter"];
}

export interface LobListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useLinesOfBusinessList = ({
  page,
  filter,
}: UseLinesOfBusinessListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListLineOfBusinessesForAccountQuery(
      { page, filter },
      { refetchOnMountOrArgChange: true }
    );

  const rows: LineOfBusiness[] = (data?.data ?? [])
    .map((lob: any) => ({
      id: String(lob.id),
      name: lob.attributes?.name ?? "",
      code: lob.attributes?.code ?? "",
      position: lob.attributes?.position ?? 0,
    }))
    // The list query exposes no `sort`, so order by position client-side.
    .sort((a, b) => a.position - b.position);

  const pageMeta: LobListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useLinesOfBusinessList;
